import { IStationSchemeObject } from "../../../interfaces";
import { toFakeUtc } from "@framework/provider-asu";

const getStationObjectKey = (obj: IStationSchemeObject) =>
  `${obj.ObjectClass}_${obj.SchemeIdBindObject}_${obj.left}_${obj.top}_${obj.right}_${obj.bottom}`;

export const mergeRecorderModeStationObjects = (
  prevObjects: IStationSchemeObject[],
  nextObjects: IStationSchemeObject[],
  windowStart: string,
  dbTz: number,
) => {
  const prevMap = new Map(prevObjects.map(obj => [getStationObjectKey(obj), obj]));
  const windowStartTime = new Date(windowStart).getTime();

  return nextObjects.map(obj => {
    if (obj.ldd !== null) {
      return obj;
    }

    const prev = prevMap.get(getStationObjectKey(obj));
    if (prev?.ldd && toFakeUtc(prev.ldd, dbTz).getTime() >= windowStartTime) return prev;

    return obj;
  });
};
